import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"

// Connects to data-controller="file-upload"
export default class extends Controller {
  static targets = ["input", "preview", "template"]
  static values = { directUploadUrl: String }

  onChange() {
    const file = this.inputTarget.files[0]
    if (!file) {
      this.clearPreview()
      return
    }

    // Show file name preview
    this.previewTarget.innerHTML = this.templateTarget.innerHTML
      .replace("{{file_name}}", file.name)
    this.previewTarget.classList.remove("hidden")

    // If this controller has direct upload URL configured, upload it now
    if (this.hasDirectUploadUrlValue) {
      this.uploadFile(file)
    }
  }

  uploadFile(file) {
    const upload = new DirectUpload(file, this.directUploadUrlValue, this)

    upload.create((error, blob) => {
      if (error) {
        this.showError(error)
      } else {
        const hiddenField = document.createElement("input")
        hiddenField.type = "hidden"
        hiddenField.name = this.inputTarget.name
        hiddenField.value = blob.signed_id
        this.inputTarget.parentNode.insertBefore(hiddenField, this.inputTarget.nextSibling)

        // Dispatch the direct-upload:end event
        this.inputTarget.dispatchEvent(new CustomEvent("direct-upload:end", {
          detail: { id: upload.id },
          bubbles: true
        }))
      }
    })
  }

  // DirectUpload callbacks for progress tracking
  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener("progress", (event) => {
      const progress = (event.loaded / event.total) * 100
      this.updateProgress(progress)
    })
  }

  updateProgress(progress) {
    const progressText = `Uploading... ${Math.round(progress)}%`
    // Update the file name display to show progress
    const fileNameElement = this.previewTarget.querySelector("span")
    if (fileNameElement && !fileNameElement.querySelector("button")) {
      fileNameElement.firstChild.textContent = `${fileNameElement.firstChild.textContent.split(' - ')[0]} - ${progressText}`
    }
  }

  showError(error) {
    this.previewTarget.innerHTML = `<span class="text-error">Upload failed: ${error}</span>`
  }

  clear(event) {
    event.preventDefault()
    this.inputTarget.value = ""

    // Remove any hidden blob input fields
    const hiddenFields = this.inputTarget.parentNode.querySelectorAll('input[type="hidden"]')
    hiddenFields.forEach(field => field.remove())

    this.clearPreview()

    // Dispatch event to notify other controllers (like book-cover) that the file was cleared
    this.inputTarget.dispatchEvent(new CustomEvent("file-upload:clear", {
      bubbles: true
    }))
  }

  clearPreview() {
    this.previewTarget.innerHTML = ""
    this.previewTarget.classList.add("hidden")
  }
}
